import React, { memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
export type ProviderNodeData = {
  label: string;
  percentage: number;
  models: string[];
  color: string;
  dimmed?: boolean;
};
// Simple SVG logos for each provider
const ProviderLogo = ({
  name,
  color
}: {
  name: string;
  color: string;
}) => {
  const size = 26;
  switch (name) {
    case 'OpenAI':
      return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" data-id="element-124">
          <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.998 5.998 0 0 0-3.998 2.9 6.042 6.042 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" fill={color} data-id="element-125" />
        </svg>;
    case 'Anthropic':
      return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" data-id="element-126">
          <path d="M13.827 3.52h3.603L24 20.48h-3.603l-6.57-16.96zm-7.258 0h3.767L16.906 20.48h-3.674l-1.477-4.2H5.23l-1.46 4.2H.165L6.57 3.52zm1.04 4.21L5.39 13.48h4.437L7.609 7.73z" fill={color} data-id="element-127" />
        </svg>;
    case 'Azure AI':
      return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" data-id="element-128">
          <path d="M13.05 4.24L7.56 18.05l-4.77 1.06L13.05 4.24z" fill={color} data-id="element-129" />
          <path d="M14.78 6.67L17.6 14.3l-5.6 4.76h9.21l-6.43-12.39z" fill={color} opacity="0.8" data-id="element-130" />
        </svg>;
    case 'Google':
      return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" data-id="element-131">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-132" />
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-133" />
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" data-id="element-134" />
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-135" />
        </svg>;
    default:
      return <div className="w-7 h-7 rounded-full" style={{
        backgroundColor: color
      }} data-id="element-136" />;
  }
};
const ProviderNode = ({
  data,
  selected
}: NodeProps<any>) => {
  const dimmed = data.dimmed === true;
  return <div className={`
        relative p-6 rounded-lg w-[320px] transition-all duration-300
        bg-[#1f1f1f] border shadow-lg
        ${dimmed ? 'opacity-20 pointer-events-none' : ''}
        ${!dimmed && selected ? 'border-white/[0.24]' : !dimmed ? 'border-white/[0.14]' : 'border-white/[0.08]'}
      `} data-id="element-137">
      <Handle type="target" position={Position.Top} className="!bg-white/20 !w-3 !h-3 !border-0" data-id="element-138" />

      <div className="flex items-center justify-between mb-4" data-id="element-139">
        <div className="flex items-center gap-3" data-id="element-140">
          <ProviderLogo name={data.label} color={data.color} data-id="element-141" />
          <span className="text-white text-[17px] font-medium" data-id="element-142">
            {data.label}
          </span>
        </div>
        <span className="text-white/50 text-[14px] font-mono" data-id="element-143">
          {data.percentage}%
        </span>
      </div>

      <div className="w-full bg-white/[0.10] rounded-full h-2 mb-4 overflow-hidden" data-id="element-144">
        <div className="h-2 rounded-full transition-all duration-1000 ease-out" style={{
        width: `${data.percentage}%`,
        backgroundColor: data.color
      }} data-id="element-145" />
      </div>

      <div className="flex flex-wrap gap-1.5" data-id="element-146">
        {data.models.map((m: string) => <span key={m} className="text-[11px] text-white/55 bg-[#2a2a2a] px-2.5 py-1.5 rounded-md border border-white/[0.12]" data-id="element-147">
            {m}
          </span>)}
      </div>
    </div>;
};
export default memo(ProviderNode);